import angular from 'angular';
import { IBancoHorasColaboradores } from '../models/bancohorascolaboradores.model';
import { LoadParams } from '../../../../shared/models/loadparams.model';

export class ExportacaoArquivoAejService {
	static $inject = ['$http', 'nsjRouting', '$rootScope', '$q'];

	public entity:  IBancoHorasColaboradores;
	public entities: Array<IBancoHorasColaboradores> = [];
	public loaded: boolean = false;
	public constructors: any = {};
	public after: any = {};
	public filters: any = {};
	public loadParams: LoadParams;
	public loading_deferred: any = null;
	public filter: any = '';

	constructor(
		public $http: angular.IHttpService,
		public nsjRouting: any,
		public $rootScope: angular.IRootScopeService,
		public $q: angular.IQService,
	) {
		this.loadParams = new LoadParams();
	}

	exportar(rota: any, constructors: any): angular.IHttpPromise<any> {
		this.loading_deferred = this.$q.defer();
		return this.$q((resolve: any, reject: any) => {
			this.$http({
				method: 'get',
				url: this.nsjRouting.generate(rota, constructors, true),
				responseType: 'blob',
				timeout: this.loading_deferred.promise
			})
			.then((response: any) => {
				var fileName = '';
				let file = new Blob([response.data]);
				let fileUrl = URL.createObjectURL(file);
				let a = document.createElement('a');
				fileName = 'AEJ_' + constructors.datainicial + '_' + constructors.datafinal + '_REP_P';
                fileName += '.zip';

				document.body.appendChild(a);
				a.style.display = 'none';
				a.href = fileUrl;
				a.download = fileName;
				a.click();
				window.URL.revokeObjectURL(fileUrl);
				this.$rootScope.$broadcast('arquivosaej_index_sucesso', response);
			})
			.catch((error) => {
				this.extraiRetornoErro(error).then((retorno: any) => {
					this.$rootScope.$broadcast('arquivosaej_index_error', {
						error: error,
						codigo: retorno.codigo,
						mensagem: retorno.mensagem
					});
				});
				console.log(error);
			});
		});
	}

	/**
	 * A exportação usa responseType 'blob', então o corpo de erro da API (JSON com
	 * o motivo, ex.: estabelecimento sem marcações no período) também chega como Blob
	 * e precisa ser lido antes de ser exibido para o usuário.
	 */
	extraiRetornoErro(error: any): angular.IPromise<any> {
		let deferred = this.$q.defer();
		let corpo = error ? error.data : null;

		if (!corpo) {
			deferred.resolve({});
			return deferred.promise;
		}

		if (!(corpo instanceof Blob)) {
			deferred.resolve({ codigo: corpo.codigo, mensagem: corpo.message });
			return deferred.promise;
		}

		let leitor = new FileReader();
		leitor.onloadend = () => {
			let retorno: any = {};
			try {
				let conteudo = JSON.parse(leitor.result as string);
				retorno = { codigo: conteudo.codigo, mensagem: conteudo.message };
			} catch (e) {
				retorno = {};
			}
			deferred.resolve(retorno);
			// o FileReader roda fora do digest do Angular
			this.$rootScope.$applyAsync();
		};
		leitor.onerror = () => {
			deferred.resolve({});
			this.$rootScope.$applyAsync();
		};
		leitor.readAsText(corpo);

		return deferred.promise;
	}

}
